import { render, staticRenderFns } from "./selfTeacherVipCard.vue?vue&type=template&id=3c88364a&scoped=true"
import script from "./selfTeacherVipCard.vue?vue&type=script&lang=js"
export * from "./selfTeacherVipCard.vue?vue&type=script&lang=js"
import style0 from "./selfTeacherVipCard.vue?vue&type=style&index=0&id=3c88364a&prod&lang=css"
import style1 from "./selfTeacherVipCard.vue?vue&type=style&index=1&id=3c88364a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88364a",
  null
  
)

export default component.exports